<template>
  <Component
    :is="tag"
    :class="[
      size && `size-${size}`,
    ]"
    class="base-section-container"
  >
    <slot />
  </Component>
</template>

<script setup lang="ts">

interface Props {
  tag: string
  size?: 'narrow' | 'middle' | 'full'
}

withDefaults(defineProps<Props>(), {})
</script>

<style lang="scss" scoped>
.base-section-container {
  width: 100%;
  margin: {
    left: auto;
    right: auto;
  }
  padding: {
    left: 1rem;
    right: 1rem;
  }

  &.size-full {
    max-width: initial;
  }

  &.size-narrow {
    max-width: 42rem;
  }

  &.size-middle {
    max-width: 56rem;
  }
}
</style>
